export function formatCurrency(num: number) {
  let dec_num = num.toFixed(2);
  return dec_num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
